import { StyleSheet } from 'react-native';

import { C } from '../../common';
import { THEME } from '../../reactor/common';

const { PAGE_HEADER_HEIGHT } = C;
const { COLOR, OFFSET, UNIT } = THEME;
const ITEM_SIZE = UNIT / 2;

export default StyleSheet.create({
  container: {
    bottom: PAGE_HEADER_HEIGHT,
    justifyContent: 'space-between',
    position: 'absolute',
    right: OFFSET,
    top: PAGE_HEADER_HEIGHT,
  },

  item: {
    backgroundColor: COLOR.BACKGROUND,
    borderRadius: ITEM_SIZE / 2,
    flex: 1,
    marginVertical: ITEM_SIZE / 2,
    minHeight: ITEM_SIZE,
    width: ITEM_SIZE,
  },

  itemAnchor: {
    flex: 5,
  },

  touchable: {
    height: '100%',
    width: '100%',
  },
});
